import { Base } from '../base/index.js';

/**
 * Component's name.
 * @type {string}
 */
export const name = 'fontsize-controls';

/**
 * Class Select.
 */
export class FontSizeControls extends Base {
  /**
   * @type {import('../../types.d.ts').BaseConfig}
   */
  static config = {
    name,
  };

  connectedCallback() {
    this.increaseBtn = this.querySelector('#fontsize-increase');
    this.decreaseBtn = this.querySelector('#fontsize-decrease');
    this.resetBtn = this.querySelector('#fontsize-reset');

    this.increaseBtn.addEventListener('click', this.increase.bind(this));
    this.decreaseBtn.addEventListener('click', this.decrease.bind(this));
    this.resetBtn.addEventListener('click', this.reset.bind(this));
  }

  /**
   * Get the current value for CSS variable --font-size-root set on <html>
   */
  get getSize() {
    return Number.parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--font-size-root'),
    );
  }

  /**
   * Increase font size
   */
  increase() {
    const currentSize = this.getSize;
    document.documentElement.style.setProperty('--font-size-root', `${currentSize + 1}px`);
    localStorage.setItem('font-size', currentSize + 1);
  }

  /**
   * decrease font size
   */
  decrease() {
    const currentSize = this.getSize;
    // Minimum font-size is 16px
    const newSize = Math.max(16, currentSize - 1);
    document.documentElement.style.setProperty('--font-size-root', `${newSize}px`);
    localStorage.setItem('font-size', newSize);
  }

  /**
   * reset font size
   */
  reset() {
    document.documentElement.style.setProperty('--font-size-root', '16px');
    localStorage.setItem('font-size', 16);
  }
}

export default FontSizeControls;
